import TopBar from "../../components/TopBar";
import Sidebar from "../../components/Sidebar";
import Gantt from "../../components/Gantt/Gantt";
import DashboardComponent from "../../components/Gantt/Dashboard";
import KanBanComponent from "../../components/Gantt/KanBan";
import FindingsComponent from "../../components/Gantt/Findings";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { compose } from "redux";
import React, { useState } from "react";



function GanttPage(props) {
  const { token, activeDepartmentId, activeDepartment } = props;

  const collapsed = false;

  // simple string state (JS-safe). If you're using TS, you can type it later.
  const [viewOption, setViewOption] = useState("Findings"); // "Project" | "Action"

  const handleViewProject = () => setViewOption("Gantt");
  const handleViewAction = () => setViewOption("Action");
  const handleViewKanBan = () => setViewOption("KanBan");
  const handleViewFindings = () => setViewOption("Findings");

  return token ? (
  <div className="flex flex-col w-full h-screen bg-[#F8F8F8] overflow-hidden">
    {/* TopBar sits at top, not fixed */}
    {!activeDepartmentId && (
      <div className="flex-shrink-0">
        <TopBar />
      </div>
    )}

    {/* Main row: Sidebar + content */}
    <div className="flex flex-1 w-full overflow-hidden">
      {/* Sidebar on the left, full height */}
      {!activeDepartmentId && (
        <div className="flex-shrink-0 h-full">
          <Sidebar collapsed={collapsed} />
        </div>
      )}

      {/* Scrollable main content */}
      <div
        id="dashboard-content"
        className={`
          flex flex-col flex-1
          w-full
          overflow-y-auto
          transition-all duration-300
        `}
      >
        {viewOption === "Gantt" ? (
          <div className="overflow-x-auto w-full h-full">
            <Gantt
              activeDepartmentId={activeDepartmentId}
              activeDepartment={activeDepartment}
            />
          </div>
        ) : viewOption === "KanBan" ? (
          <div className="overflow-x-auto w-full h-full">
            <KanBanComponent
              activeDepartmentId={activeDepartmentId}
              activeDepartment={activeDepartment}
            />
          </div>
        ) : viewOption === "Findings" ? (
          <div className="overflow-x-auto w-full h-full">
            <FindingsComponent
              activeDepartmentId={activeDepartmentId}
              activeDepartment={activeDepartment}
              viewOption={viewOption}
              onSelectFindings={handleViewFindings}
              onSelectActions={handleViewAction}
              isComp={false}
            />
          </div>
        ) : (
          <div className="overflow-x-auto w-full h-full">
            <DashboardComponent
              activeDepartmentId={activeDepartmentId}
              activeDepartment={activeDepartment}
              viewOption={viewOption}
              onSelectFindings={handleViewFindings}
              onSelectActions={handleViewAction}
            />
          </div>
        )}
      </div>
    </div>
  </div>
) : (
  <Redirect to="/login" />
);
}

const mapStateToProps = (state) => ({
  token: state.auth.token,
});

export default compose(connect(mapStateToProps))(GanttPage);
